import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
// import ShakeMobileSection from "./components/ShakeMobileSection";
// import IntroSection from "./components/IntroSection";
import DancingSection from "./components/DancingSection";
import UploadSection from "./components/UploadSection";
import VideoCreatedSection from "./components/VideoCreatedSection";
import GallerySection from "./components/GallerySection";
import TermsConditions from "./components/TermsConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Footer from "./components/Footer";
import TurnOnSection from "./components/TurnOnSection";
import TiktokCallback from "./components/TiktokCallback";
import ShareTiktokComponent from "./components/shareTiktokComponent";
import AudioComponent from "./components/AudioComponent";

function App() {
  const [isPlaying, setIsPlaying] = useState(false);
  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <>
      {/* <Canvas>
      <ambientLight intensity={1} /> 
      <NoiseEffect />
    </Canvas> */}
      <BrowserRouter>
        <Header />
        <Routes >
          <Route path="/" element={<TurnOnSection togglePlay={togglePlay} />} />
          {/* <Route path="/dancing" element={<DancingSection />} /> */}
          <Route path="/upload" element={<UploadSection />} />
          <Route path="/videos/:key" element={<VideoCreatedSection />} />
          <Route path="/gallery" element={<UploadSection />} />
          <Route path="/termsConditions" element={<TermsConditions />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/tiktok/callback" element={<TiktokCallback />} />
          <Route path="/tik" element={<ShareTiktokComponent />} />
        </Routes>
        {/* <AudioComponent isPlaying={isPlaying} togglePlay={togglePlay} /> */}
        <Footer />
      </BrowserRouter >
    </>
  );
}

export default App;
